import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import "./Admin/admin.css";
import Button from 'react-bootstrap/Button';
import MoneyMgmtQuestionCard from './money_mgmt_question_card';
import summarizeTestByQuestion from './objects/summarize_test_by_question';

class MoneyMgmtTestByQuestionModal extends Component {
  constructor(props) {
    super(props);
    this.state={
        newFilter: false,
      }    
    this.questionArr = [];
    this.prepareMoneyMgmtTestReport();
}

prepareMoneyMgmtTestReport(){
    this.playerTestData = JSON.parse(JSON.stringify(this.props.financialLiteracyTestArr));
    this.reformatTestRecords();
}

reformatTestRecords(){
     this.questionAnswerArr = [];
     for (let i=0; i<this.playerTestData.length; i++){
        let questionAnswerArr = this.playerTestData[i].questionAnswerArr;
        this.questionAnswerArr = this.questionAnswerArr.concat(questionAnswerArr);
     }
      this.questionArr = summarizeTestByQuestion(this.questionAnswerArr);
}


filterTestReport(filterValue){
    this.playerTestData = JSON.parse(JSON.stringify(this.props.financialLiteracyTestArr));
    if (filterValue === "all"){
       //  no filter applied
    }else{
        this.playerTestData = this.playerTestData.filter(elem => elem.testType === filterValue);
    }
    this.reformatTestRecords();
    this.setState({newFilter: !this.state.newFilter}); 
}

   
render() {
    let accountNbr = "";
    if (this.props.accountNbr){
        accountNbr = this.props.accountNbr;
    }
    let accountName = "";
    if (this.props.accountName){
      accountName = this.props.accountName;
    }
    this.moneyMgmtQuestions = this.questionArr.map((questionInfo, index) =>
      <MoneyMgmtQuestionCard questionInfo={questionInfo}  key={index} 
      />
          );
              
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="lg" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title className="w-100 text-center pe-4">
                Financial Lit Test Question Review - Total Number of Questions: &nbsp;
                  {this.questionArr.length}
                {accountNbr ?
                    <div><b>Selected Account: </b>{accountNbr} - {accountName}</div>
                  :
                    null
                }
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
              <span>
                <div className="backgroundTopBottom">
                   <div className="d-flex justify-content-end align-items-center">
                      <label className="font-weight-bold mr-2" htmlFor="testType"
                        style={{ whiteSpace: "nowrap" }}>
                        Filter By Test Type:
                      </label>
                      <select className="filter-select small-select mr-4" id="testType"
                        onChange={(val) => this.filterTestReport(val.target.value)}>
                        <option value="all">no filter applied</option>
                        <option value="pre-test">pre-test</option>
                        <option value="mid-test">mid-test</option>
                        <option value="post-test">post-test</option>
                      </select>
                    </div>
                </div>
              <table className="table m-0">
                <tbody>
                  <tr className="header-sticky">
                    <th>Question Nbr</th>
                    <th>Question Text</th>
                    <th>Nbr Correct</th>
                    <th>Pct Correct</th>
                    <th>Nbr Partial Correct</th>
                    <th>Nbr Wrong</th>
                    <th>Total Nbr Tests</th>
                  </tr>
                  {this.moneyMgmtQuestions}
                </tbody>
              </table>
                             
              </span>
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
             
              <Button variant="primary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
              
        </Modal.Footer>
       
    </Modal>
    
  </>
  }
}

export default MoneyMgmtTestByQuestionModal;